import React from "react";
import Chip from "../Chip";
import MUIGreyColor from "@mui/material/colors/grey";
import MUIAvatar from "@mui/material/Avatar";
import IssueReason from "../../Utility/Crud/IssueReason";

export default class ChipIssueReason extends Chip {
  /**
   * Renders a MUI Avatar.
   */
  renderAvatar() {
    const color = this.props.issueReason
      ? IssueReason.getColor()
      : MUIGreyColor[500];
    const avatarColor = this.props.isTransparent ? "transparent" : color;
    const iconColor = this.props.isTransparent ? color : "#fff";

    return (
      <MUIAvatar sx={{ bgcolor: avatarColor }}>
        {IssueReason.getIcon({ fontSize: "small", sx: { color: iconColor } })}
      </MUIAvatar>
    );
  }

  /**
   * @return {string} The issueReason name.
   */
  getLabel() {
    return this.props.issueReason
      ? IssueReason.getDisplayName(this.props.issueReason)
      : "None";
  }
}
